export default {"src":"/_next/static/media/brave-black.15d51b67.svg","height":768,"width":2501,"blurWidth":0,"blurHeight":0};